import { kmAccentForGender } from './kmLabels';
import { kmDivBadgeColor } from './divColors';

export interface KMClassTagProps {
  /** Player/class gender: 'M' (herrer), 'F' (damer) or anything else (mix). */
  gender?: string;
  /** Division name; the leading letter (A/B/C…) drives the badge color. */
  divName?: string;
  /** Extra classes appended to the wrapping tag. */
  className?: string;
}

/**
 * Composite class tag — «HERRER» (gender-colored background) + division letter
 * (division-colored). Used consistently across the KM tabs to show gender via
 * the color and division via the letter, all in one compact tag.
 * Extracted verbatim from the monolith (legacy/App.tsx); markup unchanged.
 */
export function KMClassTag({ gender, divName, className = '' }: KMClassTagProps) {
  const genderColor = kmAccentForGender(gender);
  const genderLabel = gender === 'M' ? 'HERRER' : gender === 'F' ? 'DAMER' : 'MIX';
  const divColor = divName ? kmDivBadgeColor(divName) : null;
  const letter =
    divName && /^[A-Z]$/i.test(divName.toString()) ? divName.toString().toUpperCase() : divName;
  return (
    <span
      className={`inline-flex items-stretch rounded overflow-hidden text-[9px] font-mono font-bold uppercase tracking-wider flex-shrink-0 ${className}`}
    >
      <span
        className="py-0.5 text-white text-center"
        style={{ background: genderColor, width: '3.5rem' }}
      >
        {genderLabel}
      </span>
      {letter && (
        <span
          className="px-1.5 py-0.5 text-white text-center"
          style={{ background: divColor, minWidth: '1.25rem' }}
        >
          {letter}
        </span>
      )}
    </span>
  );
}
